import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payments")({
	component: PaymentsLayout,
});

function PaymentsLayout() {
	return <Outlet />;
}
